
import { ReactNode } from "react";

interface HeroSectionProps {
  title: string;
  description: string;
  backgroundImage: string;
  rightSlot?: ReactNode;
}

export function HeroSection({ title, description, backgroundImage, rightSlot }: HeroSectionProps) {
  return (
    <section 
      className="relative pb-2 overflow-hidden"
      style={{
        backgroundImage: `url('${backgroundImage}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container max-w-5xl relative z-10">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold mb-2 text-[#1E3A8A]">{title}</h1>
            <p className="text-sm md:text-[15px] text-[#1E3A8A]/90 max-w-2xl">
              {description}
            </p>
          </div>
          {rightSlot && (
            <div className="shrink-0 mt-2 sm:mt-0">
              {rightSlot}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
